import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	archiveBrokerApi,
	ArchiveBrokerNS,
	ArchiveBrokerOrder,
	archiveBrokerSelector,
	archiveBrokerSlice,
} from 'Pages/archiveBroker'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'

function* getOne(action: ArchiveBrokerNS.GetOne) {
	try {
		const { id } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(archiveBrokerApi.getOne, id)
		yield* put(archiveBrokerSlice.actions.setOne(Deserialize(res, ArchiveBrokerOrder)))
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getAll(action: ArchiveBrokerNS.GetAll) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(archiveBrokerSlice.actions.clearAll())
		}
		const res = yield* call(archiveBrokerApi.getAll, params)
		const items = new ResponseCatalog<ArchiveBrokerOrder>(res)
		items.entries = items.entries.map(
			(item): ArchiveBrokerOrder => Deserialize(item, ArchiveBrokerOrder)
		)
		if (!clear) {
			const oldItems = yield* select(archiveBrokerSelector.selectItems)
			items.entries = [...oldItems, ...items.entries]
		}
		yield* put(archiveBrokerSlice.actions.setAll(items))
		yield* put(archiveBrokerSlice.actions.setRequestParams(params))
		callback?.()
		const id = res.entries[0]?.id
		if (id) yield* call(getOne, archiveBrokerSlice.actions.getOne({ id: String(id) }))
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getDicts() {
	try {
		const orderRefusalStatuses = yield* call(archiveBrokerApi.getOrderRefusalStatuses)
		yield* put(archiveBrokerSlice.actions.setOrderRefusalStatuses(orderRefusalStatuses.entries))
	} catch (e) {
		yield* call(errorHandler, e)
	}
}

function* getOrderStatuses(action: ArchiveBrokerNS.GetOrderStatuses) {
	try {
		const { params } = action.payload
		const orderStatuses = yield* call(archiveBrokerApi.getOrderStatuses, params)
		yield* put(archiveBrokerSlice.actions.setOrderStatuses(orderStatuses.entries))
	} catch (e) {
		yield* call(errorHandler, e)
	}
}

function* sendReport(action: ArchiveBrokerNS.SendReport) {
	try {
		const { params } = action.payload
		yield* call(archiveBrokerApi.archiveOrderReport, params)
	} catch (e) {
		yield* call(errorHandler, e)
	}
}

function* getContactUser(action: ArchiveBrokerNS.GetContactUser) {
	try {
		const { id } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const contactDetails = yield* call(archiveBrokerApi.getContactDetails, id)
		const currentOrder = yield* select(archiveBrokerSelector.selectOrder)
		yield* put(
			archiveBrokerSlice.actions.setOne(
				Deserialize(
					{ ...currentOrder, contact_details: contactDetails.contact_details },
					ArchiveBrokerOrder
				)
			)
		)
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* archiveBrokerSaga() {
	yield* takeLatest(archiveBrokerSlice.actions.getAll.type, getAll)
	yield* takeLatest(archiveBrokerSlice.actions.getOne.type, getOne)
	yield* takeLatest(archiveBrokerSlice.actions.getDicts.type, getDicts)
	yield* takeLatest(archiveBrokerSlice.actions.getOrderStatuses.type, getOrderStatuses)
	yield* takeLatest(archiveBrokerSlice.actions.sendReport.type, sendReport)
	yield* takeLatest(archiveBrokerSlice.actions.getUserContact.type, getContactUser)
}
